var hoverColors = {
  base: "grey.8",
  background: "grey.3",
  "grey.8": "grey.3"
};
var hoverColor = function hoverColor(backgroundColor) {
  if (Array.isArray(backgroundColor)) {
    return backgroundColor.map(function (color) {
      return color ? hoverColors[String(color)] : "grey.8";
    });
  }
  return (backgroundColor ? hoverColors[String(backgroundColor)] : undefined) || "grey.8";
};
export { hoverColor };